var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItinerarios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1, 1)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52631579,15.4620844 L2.52631579,4.41998164 C2.52631579,1.97889319 4.50520898,4.48420674e-16 6.94629743,0 C9.38738588,-4.48420674e-16 11.3662791,1.97889319 11.3662791,4.41998164 L11.3662791,19.5778764 C11.3662791,22.0201478 13.3461313,24 15.7884027,24 C18.2306741,24 20.2105263,22.0201478 20.2105263,19.5778764 L20.2105263,8.47257309 L20.2105263,8.47257309",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    x: 0,
    y: 18.9473684,
    width: 5.05263158,
    height: 5.05263158
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 20.2105263,
    cy: 2.52631579,
    r: 2.52631579
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItinerarios);
export default __webpack_public_path__ + "static/media/Itinerarios.1ec1bc17e273fef6846cc86815e93378.svg";
export { ForwardRef as ReactComponent };